import { Component, Vue, } from 'vue-property-decorator';
import ActionIcon from '@/components/action-icon/ActionIcon.vue';

@Component<ActionDeleteIcon>({
  components: {
    'action-icon': ActionIcon,
  }
})
export default class ActionDeleteIcon extends Vue { }
